import React from "react";
import "./Footer.css";
import { socialMediaIcons } from "./socialMediaIcons";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer-block">
          <p className="footer-title">Expertise</p>
          <ul className="footer-list">
            <li className="footer-item">Software Development</li>

            <li className="footer-item">Cloud Infrastructure DevOPS</li>

            <li className="footer-item">Customers Success Stories</li>
          </ul>
        </div>
        <div className="footer-block">
          <p className="footer-title">About Us</p>

          <ul className="footer-list">
            <li className="footer-item">We're Hiring!</li>

            <li className="footer-item">Who We Are</li>

            <li className="footer-item">Culture</li>
          </ul>
        </div>
        <div className="footer-block">
          <p className="footer-title">Cloud</p>
          <ul className="footer-list">
            <li className="footer-item">G Cloud</li>
            <li className="footer-item">Google Workspace</li>
            <li className="footer-item">Cloud Offer</li>
          </ul>
        </div>
        <div className="footer-block">
          <p className="footer-title">Zazmic Software</p>
          <ul className="footer-list">
            <li className="footer-item">Z-Stream</li>
          </ul>
        </div>
        <div className="footer-block">
          <p className="footer-title">Contact</p>
          <ul className="footer-list">
            <li className="footer-address">
              Salesforce Tower 415 Mission St, San Francisco, CA 94105
            </li>
            <li className="footer-item">Phone: 415-728-1621</li>
            <li className="footer-item">Email: sales@zazmic.com</li>
          </ul>
          <button className="footer-btn">Contact Us</button>
        </div>
      </div>
      <div className="copyright">
        
          <div className="copyright-block">
            <img
              src="https://www.zazmic.com/wp-content/themes/zazmic/img/copyright@2x.png"
              alt="ai"
              className="footer__img"
            />
            <p className="copyright-copyright">Copyright 2012-2023 Zazmic Inc. All Rights Reserved. Designed by Zazmic Inc.</p>

          </div>

          <div className="footer__social">
            {socialMediaIcons.map((item, index) => (
              <div key={index} className="content__social-media">
                {item.icon}
              </div>
            ))}
          </div>
        
      </div>
    </footer>
  );
};

export default Footer;
